module.exports = __webpack_public_path__ + "static/media/cultura.105fa5d1.png";